import { Navigate, Outlet, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import Footer from '../components/Footer';
import ConsoleNavbar from '../components/ConsoleNavbar';
import useAuth from '../hooks/useAuth';
import FeedbackView from '../components/FeedbackView';

function ConsoleLayout() {
  const auth = useAuth();
  const { pathname } = useLocation();

  const [showFeedback, setShowFeedback] = useState(false);

  const handleFeedbackShow = () => setShowFeedback(true);
  const handleFeedbackClose = () => setShowFeedback(false);

  if (auth.isAuth()) {
    return (
      <>
        <div id="wrap">
          <ConsoleNavbar onFeedbackShow={handleFeedbackShow} />
          <div className="container-fluid" style={{ minHeight: '60vh' }}>
            <div className="row">
              <main className="col-md-12 ms-sm-auto col-lg-12 px-md-0">
                <Outlet />
              </main>
            </div>
          </div>
        </div>

        <Footer />

        <FeedbackView show={showFeedback} onClose={handleFeedbackClose} />
      </>
    );
  }

  return <Navigate to={`/login?redirect=${encodeURIComponent(pathname)}`} replace />;
}

export default ConsoleLayout;
